const getExtraRecapitulatifMessageInfo = (getMiddleText) =>
  getMiddleText('RECAPITULATIF_MESSAGE_INFO');

export default getExtraRecapitulatifMessageInfo;
